function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.9928 0.292893L19.7071 4.00718C20.0976 4.3977 20.0976 5.03087 19.7071 5.42139L10.4214 14.7071C10.2339 14.8946 9.9795 15 9.71429 15H6C5.44772 15 5 14.5523 5 14V10.2857C5 10.0205 5.10536 9.76614 5.29289 9.57861L14.5786 0.292893C14.9691 -0.0976311 15.6023 -0.0976311 15.9928 0.292893ZM7 10.6999V13H9.30007L17.5858 4.71429L15.2857 2.41421L7 10.6999ZM17 11.4756C16.4477 11.4756 16 11.9233 16 12.4756V17.2222C16 17.6518 15.6518 18 15.2222 18H2.77778C2.34822 18 2 17.6518 2 17.2222V4.77778C2 4.34822 2.34822 4 2.77778 4H7.52444C8.07673 4 8.52444 3.55228 8.52444 3C8.52444 2.44772 8.07673 2 7.52444 2H2.77778C1.24365 2 0 3.24365 0 4.77778V17.2222C0 18.7563 1.24365 20 2.77778 20H15.2222C16.7563 20 18 18.7563 18 17.2222V12.4756C18 11.9233 17.5523 11.4756 17 11.4756Z",
  fill: "#999999"
});

var SvgTemplateEditIcon = function SvgTemplateEditIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTemplateEditIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TemplateEditIcon.642c134d.svg";
export { ForwardRef as ReactComponent };